import { Separator } from "../components/ui/separator";

const BELIEFS_IMG = "https://images.unsplash.com/photo-1641491630495-d24e380af960?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxvcGVuJTIwYmlibGUlMjBjcm9zcyUyMGxpZ2h0fGVufDB8fHx8MTc3NjM1MjEwMXww&ixlib=rb-4.1.0&q=85";

const beliefs = [
  {
    title: "Faith in God",
    content:
      "We believe in one God, Creator of all things, who is present and active in our lives. Our work is grounded in the conviction that faith provides the foundation for all learning and growth.",
  },
  {
    title: "The Importance of Family",
    content:
      "We believe the family is the cornerstone of society and education. Parents are the primary educators of their children, and our role is to support and strengthen that sacred responsibility.",
  },
  {
    title: "Education as Ministry",
    content:
      "We believe education is a form of ministry. When done with intention and rooted in faith, education becomes a powerful tool for shaping character and building community.",
  },
  {
    title: "Integrity and Accountability",
    content:
      "We believe in operating with honesty, maintaining proper records, and holding ourselves to the highest ethical standards in all that we do.",
  },
  {
    title: "Service to Others",
    content:
      "We believe we are called to serve. Our mission is to provide structure and support to those who are educating the next generation in a faith-centered environment.",
  },
  {
    title: "Community and Fellowship",
    content:
      "We believe in the power of community. Though we operate virtually, we are committed to building genuine connections among the families and churches we serve.",
  },
];

export default function BeliefsPage() {
  return (
    <div data-testid="beliefs-page">
      {/* Header */}
      <section className="bg-[#1C2E4A] py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <p className="text-xs uppercase tracking-[0.2em] text-[#C8A97E] font-semibold mb-3">
            Statement of Faith
          </p>
          <h1
            data-testid="beliefs-headline"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight max-w-3xl"
          >
            What We Believe
          </h1>
        </div>
      </section>

      {/* Image + Intro */}
      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="rounded-xl overflow-hidden shadow-lg order-2 lg:order-1">
            <img
              src={BELIEFS_IMG}
              alt="Faith and Scripture"
              className="w-full h-72 lg:h-96 object-cover"
            />
          </div>
          <div className="order-1 lg:order-2">
            <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold text-[#1C2E4A] mb-6">
              Grounded in Faith, Focused on Service
            </h2>
            <p className="text-[#595959] leading-relaxed">
              Our beliefs are simple and foundational. We hold to the essential
              truths that guide our mission to serve families and churches. We do
              not seek to divide over theological complexities but rather to unite
              around the core values of faith, family, and education.
            </p>
          </div>
        </div>
      </section>

      {/* Beliefs List */}
      <section data-testid="beliefs-list-section" className="py-20 md:py-28 bg-[#FAF9F6]">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <div className="text-center mb-14">
            <p className="text-xs uppercase tracking-[0.2em] text-[#C8A97E] font-semibold mb-3">
              Core Beliefs
            </p>
            <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold text-[#1C2E4A]">
              Our Foundation
            </h2>
          </div>
          <div className="space-y-0">
            {beliefs.map((belief, i) => (
              <div key={belief.title}>
                <div
                  data-testid={`belief-item-${i}`}
                  className="py-8"
                >
                  <div className="flex items-start gap-5">
                    <span className="font-serif text-3xl font-bold text-[#C8A97E]/40 leading-none mt-1 select-none">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <div>
                      <h3 className="font-serif text-xl font-semibold text-[#1C2E4A] mb-2">
                        {belief.title}
                      </h3>
                      <p className="text-sm text-[#595959] leading-relaxed">
                        {belief.content}
                      </p>
                    </div>
                  </div>
                </div>
                {i < beliefs.length - 1 && <Separator className="bg-[#E5E2DC]" />}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
